import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axiosInstance from "../axios/axios";
import SuccessMessage from "../components/SuccessMessage";

const EditJob = () => {
  const { id } = useParams(); // Destructure `id` from URL params
  const [updatedJob, setUpdatedJob] = useState({});
  const [success, setSuccess] = useState("");

  const navigate = useNavigate();

  useEffect(() => {
    const fetchJobById = async () => {
      try {
        const res = await axiosInstance.get(`view/jobs/${id}`);
        console.log(res.data.job);
        setUpdatedJob(res.data.job);
      } catch (error) {
        console.log(error);
      }
    };
    if (id) fetchJobById();
  }, [id]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setUpdatedJob((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleEditJobs = async (e) => {
    e.preventDefault();

    try {
      const res = await axiosInstance.put(`jobs/${id}`, updatedJob);
      console.log(res);
      setSuccess(res.data.message || "Job Edited Successfully");
      setTimeout(() => navigate("/dashboard/jobs"), 2000); // ✅ Smooth transition
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div className="mt-6 p-4 flex items-center justify-center flex-col gap-4 ">
      {success && <SuccessMessage message={success} />}
      <div className="top-bar">
        <span>Edit Job</span>
      </div>
      <form
        onSubmit={handleEditJobs}
        className="flex flex-wrap flex-col gap-3 mt-6 md:w-[60%]"
      >
        {/* Job Title */}
        <div className="flex flex-col gap-2 ">
          <label className="form-label">Job Title</label>
          <input
            required
            type="text"
            name="job_title"
            value={updatedJob.job_title || ""}
            onChange={handleChange}
            className="border py-2 px-3 rounded-lg custom-form"
          />
        </div>

        {/* Department */}
        <div className="flex flex-col gap-2 ">
          <label className="form-label">Department</label>
          <input
            required
            type="text"
            name="department"
            value={updatedJob.department || ""}
            onChange={handleChange}
            className="border py-2 px-3 rounded-lg custom-form"
          />
        </div>

        {/* Amount if stipend */}
        {updatedJob.stipend == "1" && (
          <div className="flex flex-col gap-2 ">
            <label className="form-label">Amount Range</label>
            <input
              required
              type="text"
              name="amount"
              value={updatedJob.amount || ""}
              placeholder="(e.g. 1000 - 2000 NGN)"
              onChange={handleChange}
              className="border py-2 px-3 rounded-lg custom-form"
            />
          </div>
        )}

        {/* Duration */}
        <div className="flex flex-col gap-2 ">
          <label className="form-label">Duration</label>
          <input
            required
            type="text"
            name="duration"
            placeholder="(e.g. 6 months)"
            value={updatedJob.duration || ""}
            onChange={handleChange}
            className="border py-2 px-3 rounded-lg custom-form"
          />
        </div>

        {/* Deadline */}
        <div className="flex flex-col gap-2">
          <label className="form-label">Application Deadline</label>
          <input
            type="date"
            name="deadline"
            value={updatedJob.deadline || ""}
            onChange={handleChange}
            className="border py-2 px-3 rounded-lg custom-form"
          />
        </div>

        {/* Field */}
        <div className="flex flex-col gap-2 ">
          <label className="form-label">Field</label>
          <select
            required
            name="field"
            value={updatedJob.field || ""}
            onChange={handleChange}
            className="border py-2 px-3 rounded-lg custom-form"
          >
            <option value="">Select Option</option>
            <option value="Art">Art</option>
            <option value="Science">Science</option>
            <option value="Commercial">Commercial</option>
          </select>
        </div>

        {/* Stipend */}
        <div className="flex flex-col gap-2 ">
          <label className="form-label">Stipend</label>
          <select
            required
            name="stipend"
            value={updatedJob.stipend?.toString() || ""}
            onChange={handleChange}
            className="border py-2 px-3 rounded-lg custom-form"
          >
            <option value="">Select Option</option>
            <option value="0">No</option>
            <option value="1">Yes</option>
          </select>
        </div>

        {/* Work Environment */}
        <div className="flex flex-col gap-2 ">
          <label className="form-label">Work Environment</label>
          <select
            required
            name="env_mode"
            value={updatedJob.env_mode || ""}
            onChange={handleChange}
            className="border py-2 px-3 rounded-lg custom-form"
          >
            <option value="">Select Option</option>
            <option value="onsite">Onsite</option>
            <option value="remote">Remote</option>
            <option value="hybrid">Hybrid</option>
          </select>
        </div>

        {/* Job Description */}
        <div className="flex flex-col gap-2 ">
          <label className="form-label">Job Description</label>
          <textarea
            required
            name="job_description"
            value={updatedJob.job_description || ""}
            onChange={handleChange}
            className="border py-2 px-3 rounded-lg custom-form"
          ></textarea>
        </div>

        {/* Requirements */}
        <div className="flex flex-col gap-2 ">
          <label className="form-label">Role Overview and Requirements</label>
          <textarea
            required
            name="job_requirements"
            value={updatedJob.job_requirements || ""}
            onChange={handleChange}
            className="border py-2 px-3 rounded-lg custom-form"
          ></textarea>
        </div>

        {/* Extra Questions q1–q5 */}
        {[1, 2, 3, 4, 5].map((num) => (
          <div key={num} className="flex flex-col gap-2">
            <label className="form-label">Extra Question {num}</label>
            <input
              type="text"
              name={`q${num}`}
              value={updatedJob[`q${num}`] || ""}
              onChange={handleChange}
              placeholder={`Enter extra question ${num}`}
              className="border py-2 px-3 rounded-lg custom-form"
            />
          </div>
        ))}

        {/* Submit */}
        <button type="submit" className="btn btn-success">
          Finish
        </button>
      </form>
    </div>
  );
};

export default EditJob;
